// extracted by mini-css-extract-plugin
module.exports = {"gallery-banner":"Gallery_gallery-banner__35dpR","gallery-banner-gradient":"Gallery_gallery-banner-gradient__w5cZG","gallery-title":"Gallery_gallery-title__OIWf7"};